/**
 * Hands the store link to the operating system, so the App Store or Play Store app opens it.
 *
 * Unlike `openExternalUrl`, this never uses the in-app Safari sheet on iOS: Capacitor answers
 * `window.open` with `UIApplication.open`, which lets the App Store app claim the link. Android
 * turns it into an `ACTION_VIEW` intent that the Play Store app claims.
 */
export function openStorePage(url: string): void {
	window.open(url, '_blank', 'noopener,noreferrer');
}
